// src/asset-delivery/config.ts

export const ASSET_CDN_ORIGIN =
  process.env.NEXT_PUBLIC_MEDIA_ORIGIN || "https://media.townlit.com";
